import BynderImage from "./BynderImage";

export default BynderImage;
